import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import arvoreService from '../services/arvoreService';

const initialState = {
  error: false,
  success: false,
  loading: false,
  arvoreLinhas: [],
  arvoreEquip: [],
  searchMaquinario: false,
};

export const getArvoreLinhas = createAsyncThunk('arvore/getArvoreLinhas', async (_, thunkAPI) => {
  const response = await arvoreService.getArvoreLinhas();
  if (response.errors) {
    return thunkAPI.rejectWithValue(response.errors);
  }
  return response;
});

export const getArvoreEquips = createAsyncThunk('arvore/getArvoreEquip', async (id, thunkAPI) => {
  const response = await arvoreService.getArvoreEquips(id);
  if (response.errors) {
    return thunkAPI.rejectWithValue(response.errors);
  }
  return response;
});

export const getArvorePecas = createAsyncThunk('arvore/getArvorePecas', async (id, thunkAPI) => {
  const response = await arvoreService.getArvorePecas(id);
  if (response.errors) {
    return thunkAPI.rejectWithValue(response.errors);
  }
  return response;
});

export const getSearchMaquinario = createAsyncThunk(
  'arvore/getSearchMaquinario',
  async (tag, thunkAPI) => {
    const response = await arvoreService.getSearchMaquinario(tag);
    if (response.errors) {
      return thunkAPI.rejectWithValue(response.errors);
    }
    return response;
  }
);
export const arvoreSlice = createSlice({
  name: 'arvore',
  initialState,
  reducers: {
    resetArvore: (state) => {
      state.loading = false;
      state.error = false;
      state.success = false;
    },
    resetSearch: (state) => {
      state.loading = false;
      state.error = false;
      state.searchMaquinario = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getArvoreLinhas.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getArvoreLinhas.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.arvoreLinhas = action.payload;
      })
      .addCase(getArvoreLinhas.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getArvoreEquips.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getArvoreEquips.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.arvoreEquip = action.payload;
      })
      .addCase(getArvoreEquips.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.arvoreEquip = [];
      })
      .addCase(getSearchMaquinario.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.searchMaquinario = false;
      })
      .addCase(getSearchMaquinario.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.searchMaquinario = action.payload;
      })
      .addCase(getSearchMaquinario.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.searchMaquinario = 'notFound';
        state.arvoreEquip = [];
      });
  },
});

export const { resetArvore, resetSearch } = arvoreSlice.actions;
export default arvoreSlice.reducer;
